import Vue from "vue";
import axios from "axios";
import { contractColumns } from "@/columns";
//import ActivityFlowDialogLocker from "@/components/activity_flow/ActivityFlowDialogLocker.vue";

const vue = new Vue();

export const ContractsPaymentgetTableData = async function (thisSales) {
  //console.log("penddingPaymentgetTableData");
  //const axiosSource = axios.CancelToken.source();
  var request = null;
  if (request) cancel();
  const axiosSource = axios.CancelToken.source();
  request = { cancel: axiosSource.cancel, msg: "Loading..." };

  let tableData = [];

  const Parameters = {
    params: {
      CompanyCode: thisSales.currentCompany,
      SellerCode: thisSales.currentUser.PersonCode,
      CustomerServicesCode: thisSales.currentUser.CustomerServiceExec_, //!= null ? this.currentUser.CustomerServiceExec_ : 0,
      EmployeeId: thisSales.currentUser.EmployeeId,
      UserId: thisSales.currentUser.UserID,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      optionStr: "cv"
    }
  };

  if (
    //thisSales.currentUser.Roles.some((e) => e.Id === 19 || e.Id === 25)
    thisSales.currentUser.PositionID == 52 ||
    thisSales.currentUser.PositionID == 34 ||
    thisSales.currentUser.PositionID == 117 ||
    thisSales.currentUser.PositionID == 74 ||
    thisSales.currentUser.PositionID == 16
  ) {
    await vue.$http
      .get("/api/MessageApi/GetExcutiveStatDetails", Parameters)
      .then((response) => {
        tableData = response.data[0].Contracts;
      })
      .catch((error) => {
        console.error(error);
      });
    return tableData;
  } else {
    return tableData;
  }
};
const cancel = function () {
  this.request.cancel();
  this.clearOldRequest("Cancelled");
};

export const ContractsTaksColumns = contractColumns;

export const ContractsPaymentActions = [
  {
    icon: "el-icon-view",
    label: "Ver Lineas de Contrato",
    command: "view-contract-Lines-command",

    condition: (row) => {
      //console.log("condition: ", row);
      return row.NoContrato !== undefined;
    } //Si la solicitud tiene un campo "Tipo de Solicitud" entonces muestra este action
  },
  {
    icon: "el-icon-date",
    label: "Renovar contrato",
    command: "contract-renovation-command",
    condition: (row) => {
      //console.log("condition: ", row);
      return row.NoContrato !== undefined;
    }
  },
  {
    icon: "el-icon-s-release",
    label: "Cancelar Contrato",
    command: "contract-cancelation-command",

    condition: (row) => {
      //console.log("condition: ", row);
      return row.NoContrato !== undefined;
    }
  }
];
/*
export const ContractsPaymentActionHandler = async function (action) {
  ActivityFlowDialogLocker.methods.actionHandlerHelper(action);
};
*/
